import React from 'react'
import { format } from 'date-fns'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import InputLabel from '@mui/material/InputLabel'
import FormControl from '@mui/material/FormControl'
import FormLabel from '@mui/material/FormLabel'
import FormControlLabel from '@mui/material/FormControlLabel'
import RadioGroup from '@mui/material/RadioGroup'
import Radio from '@mui/material/Radio'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import Autocomplete from '@mui/material/Autocomplete'
import Checkbox from '@mui/material/Checkbox'
import { ChromePicker } from 'react-color'

import Tags from './Tags'

const ObjectForm = ({obj, stc, labels, ignored, disabled, types, changed, recall, submit, controlled, options, custom, customData, sx = {},  ...rest}) => {
	//.log(labels)
	const [values, setValues] = React.useState(controlled)
	
	const controlledChange = ({name, value}) => {
		setValues({...values, [name]: value})
		//.log(value)
	}
	
	const refs = []
	const form = { ...obj, ...stc }
	const getRef = () => {
		const ref = React.createRef()
		refs.push(ref)
		return ref
	}


	React.useEffect(() => {
		if(recall){
			refs.forEach( r => {
				let input = r.current.querySelector("input")
				if(!input)
					input = r.current.querySelector("textarea")
				if(input.type == 'checkbox')
					form[input.name] = input.checked?1:0
				else if (input.type == 'radio')
					input.checked && (form[input.name] = input.value)
				else if (input.name.includes('tag-'))
					form[input.name.replace('tag-', '')] = input.value
				else
					form[input.name] = input.value
			})
			submit({...form, ...values})
		}
	}, [recall])
	const _obj = Object.keys(obj)
	return (
		<Box sx={{display:'flex', justifyContent:'flex-start', alignItems:'flex-start', ...sx}}>
			<Box sx={{padding: "15px"}} autoComplete="off" noValidate>
				{_obj && _obj.map((key, i) => (
					typeof(obj[key]) != 'object' && 
						!ignored.includes(key) && (
							types[key] == 'tag'?
								<Tags inputRef={getRef()} name={key} defaultTags={changed && changed[key]?changed[key]:obj[key]}/>
								
							:types[key] == 'color'?
								<FormControl sx={{ m: 1, width: '25ch' }}>
									<InputLabel id={"label-"+key}>{labels && labels[key]?labels[key]:key+`${changed && changed[key]?'*':''}`}</InputLabel>
									<ChromePicker 
										color={values[key]} 
										onChange={(color) => controlledChange({name:key, value:color.hex })
									}/>
								</FormControl>
							:types[key] == 'email'?
								<FormControl sx={{ m: 1, width: '25ch' }}>
									<TextField key={i} multiline variant="outlined"
										disabled={disabled && disabled[key]?true: false}
										ref={getRef()}
										label={labels && labels[key]?labels[key]:key+`${changed && changed[key]?'*':''}`}
										name={key}
										type="email"
										defaultValue={changed && changed[key]?changed[key]:obj[key]}
									/>
								</FormControl>
							:types[key] == 'radio'?
								<FormControl sx={{ m: 1, width: '25ch' }}>
									<FormLabel id={"label-"+key}>{labels && labels[key]?labels[key]:key+`${changed && changed[key]?'*':''}`}</FormLabel>
									<RadioGroup
										aria-labelledby={"label-"+key}
										defaultValue={changed && changed[key]?changed[key]:obj[key]}
										name={key}
									>
										{options[key].map(so => ( <FormControlLabel value={so.value} label={so.label} control={<Radio ref={getRef()} />} />  ))}
									</RadioGroup>
								</FormControl>
							:types[key] == 'select'?
								<FormControl sx={{ m: 1, width: '25ch' }} ref={getRef()}>
									<InputLabel id={"label-"+key}>{labels && labels[key]?labels[key]:key+`${changed && changed[key]?'*':''}`}</InputLabel>
									<Select
										disabled={disabled && disabled[key]?true: false}
										labelId={"label-"+key}
										name={key}
										label={labels && labels[key]?labels[key]:key+`${changed && changed[key]?'*':''}`}
										defaultValue={changed && changed[key]?changed[key]:obj[key]}
									>
										{options[key].map(so => ( <MenuItem value={so.value}>{so.label}</MenuItem>  ))}
									</Select>
								</FormControl>
							:types[key] == 'select-controlled'?
								<FormControl sx={{ m: 1, width: '25ch' }} ref={getRef()}>
									<InputLabel id={"label-"+key}>{labels && labels[key]?labels[key]:key+`${changed && changed[key]?'*':''}`}</InputLabel>
									<Select
										disabled={disabled && disabled[key]?true: false}
										labelId={"label-"+key}
										name={key}
										label={labels && labels[key]?labels[key]:key+`${changed && changed[key]?'*':''}`}
										defaultValue={changed && changed[key]?changed[key]:obj[key]}
										onChange={(e) => controlled[key]((e.currentTarget || e.target).value)}
									>
										{options[key].map(so => (
										<MenuItem value={so.value}>{so.label}</MenuItem>
										))}
									</Select>
								</FormControl>
							:types[key] == 'select-search'?
								<FormControl sx={{ m: 1, width: '25ch' }}>
									<Autocomplete
										disabled={disabled && disabled[key]?true: false}
										disablePortal
										id="combo-box-demo"
										labelId={"label-"+key}
										name={key}
										label={labels && labels[key]?labels[key]:key+`${changed && changed[key]?'*':''}`}
										options={options[key]}
										sx={{ width: 300 }}
										renderInput={(params) => <TextField {...params} label="Producto" />}
										getOptionLabel={(opt)=> `${opt["label"]}`}
										onChange={(event, opt) =>  controlledChange({name:key, value:opt.value }) }
									/>
								</FormControl>
							:types[key] == 'date'?
								<FormControl sx={{ m: 1, width: '25ch' }}>
									<DatePicker
										disabled={disabled && disabled[key]?true: false}
										label={labels && labels[key]?labels[key]:key+`${changed && changed[key]?'*':''}`}
										name={key} 
										onChange={(m) => m && controlledChange({name:key, value: format(m, 'yyyy-MM-dd') })}
										value={values[key]?values[key]:null}
										inputFormat="yyyy-MM-dd"
										defaultValue={null}
										renderInput={(params) => <TextField {...params} inputProps={{...(params.inputProps || {}), readOnly: true}} />}
									/>
								</FormControl>
							:types[key] == 'date-month'?
								<FormControl sx={{ m: 1, width: '25ch' }}>
									<DatePicker
									  	views={['year', 'month']}
										disabled={disabled && disabled[key]?true: false}
										label={labels && labels[key]?labels[key]:key+`${changed && changed[key]?'*':''}`}
										name={key} 
										onChange={(m) => m && controlledChange({name:key, value: format(m, 'yyyy-MM') })}
										value={values[key]?values[key]+"-1":null}
										inputFormat="yyyy-MM"
										defaultValue={null}
										renderInput={(params) => <TextField {...params} inputProps={{...(params.inputProps || {}), readOnly: true}} />}
										
									/>
								</FormControl>
							:types[key] == 'money'?
								<FormControl sx={{ m: 1, width: '25ch' }}>
									<TextField key={i} multiline variant="outlined" 
										disabled={disabled && disabled[key]?true: false}
										label={labels && labels[key]?labels[key]:key+`${changed && changed[key]?'*':''}`}
										name={key}
										onChange={({target}) => controlledChange(target)}
										value={values[key]}
										type="number"
									/>
								</FormControl>
							:types[key] == 'password'?
								<FormControl sx={{ m: 1, width: '25ch' }}>
									<TextField key={i} variant="outlined" 
										disabled={disabled && disabled[key]?true: false}
										ref={getRef()} 
										label={labels && labels[key]?labels[key]:key+`${changed && changed[key]?'*':''}`} 
										name={key} 
										defaultValue={changed && changed[key]?changed[key]:obj[key]}
										type="password"
									/>
								</FormControl>
							:types[key] == 'number'?
								<FormControl sx={{ m: 1, width: '25ch' }}>
									<TextField key={i} multiline variant="outlined" 
										disabled={disabled && disabled[key]?true: false}
										ref={getRef()} 
										label={labels && labels[key]?labels[key]:key+`${changed && changed[key]?'*':''}`} 
										name={key} 
										defaultValue={changed && changed[key]?changed[key]:obj[key]}
										type="number"
									/>
								</FormControl>
							:types[key] == 'check'?
								<FormControl sx={{ m: 1, width: '25ch' }}>
									<Checkbox
										disabled={disabled && disabled[key]?true: false}
										ref={getRef()}
										name={key}
										label={labels && labels[key]?labels[key]:key+`${changed && changed[key]?'*':''}`} 
									/>
									<InputLabel id={"label-"+key}>{labels && labels[key]?labels[key]:key+`${changed && changed[key]?'*':''}`}</InputLabel>
								</FormControl>
							:types[key] == 'custom'?
								<Box sx={{ m: 1 }}>
									{ custom[key]({ onChange: controlledChange, data:customData[key], key }) }
								</Box>
							:
								<FormControl sx={{ m: 1, width: '25ch' }}>
									<TextField key={i} multiline variant="outlined" 
										disabled={disabled && disabled[key]?true: false}
										ref={getRef()} 
										label={labels && labels[key]?labels[key]:key+`${changed && changed[key]?'*':''}`} 
										name={key} 
										defaultValue={changed && changed[key]?changed[key]:obj[key]}
									/>
								</FormControl>
						)
					)
				)}
			</Box>
		</Box>
	)
}
export default ObjectForm